<template>
<v-container>
    <div class="account-facebook mt-1">

        <v-avatar :size="40">

            <img :src="ImagePhoto" />

        </v-avatar>
        <div style="margin-left: 10px;font-weight: bold;">
            {{ facebook_name }}
        </div>

    </div>
    <v-divider class="mt-2"></v-divider>
    <v-row class="mt-3">
        <v-col cols="8" lg="8" xs="8" sm="8" md="8">
            <v-select @change="refreshData()" v-model="selectPage" :items="getPages" item-value="id" item-text="name" :return-object="true" label="Select Pages" outlined dense></v-select>

        </v-col>
        <v-col cols="4" lg="4" xs="4" sm="4" md="4">
            <v-btn id="btn_login" :loading="LoadingPost" :disabled="LoadingPost" block class="ma-0 red darken-1 white--text font-weight-black " @click="getContent()" loading-text="Getting Video">
                {{ TextProcessLink }}

            </v-btn>
        </v-col>
    </v-row>
    <v-row class="mt-3" v-if="hide_option">
        <v-col cols="12">
            <p style="text-align: center;font-weight: bold;"> Total Video : {{ allContent.length }}</p>
        </v-col>
    
    </v-row>
    <!-- <v-row>

    </v-row> -->
    <v-row v-if="hide_action"> 
        
        <v-col cols="6" style="text-align: left;">
            <p style="color: green;font-weight: bold;">Sucess Deleted : {{ isSuccess }}</p>
        </v-col>
        <v-col cols="6"  style="text-align: right;">
            <p style="color: red;font-weight: bold;">Error Deleted  : {{ isError }}</p>
        </v-col>
        <v-col cols="12" v-if="loadingDelete">
            <p style="text-align: center; font-weight: bold;">Starting Delete {{ num_of_delete }} of {{ allContent.length }} Video </p>
        </v-col>

        <v-col cols="12" style="text-align: center;" v-if="this.isHaveLoadeMore ">
            <v-btn id="btn_login"  :loading="LoadingLoreMore" :disabled="LoadingLoreMore"  class="ma-0 red darken-1 white--text font-weight-black " @click="loadMoreContent()" loading-text="Getting Video">
                <v-icon color="white" class="mr-1">
                    mdi-cached
                    </v-icon>  {{ TextLoademore }}

            </v-btn>
        </v-col>
        <v-col cols="12" class="mt-3" >
            <v-btn id="btn_login" block  :loading="loadingDelete" :disabled="loadingDelete"  class="ma-0 red darken-1 white--text font-weight-black " @click="autodelete()" loading-text="Getting Video">
                <v-icon color="white" class="mr-1">
                    mdi-radiobox-marked
                    </v-icon>
                    {{ text_delete }}

            </v-btn>
        </v-col>

        <v-col cols="12" v-if="isDelete" >
            <v-btn id="btn_login"  block   class="ma-0 red darken-1 white--text font-weight-black " @click="stopdelete()" loading-text="Getting Video">
                <v-icon color="white" class="mr-1">
                    mdi-radiobox-blank
                    </v-icon>Stop

            </v-btn>
        </v-col>
    </v-row>

    <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</v-container>
</template>

<script>
import axios from 'axios'
const source = axios.CancelToken.source();
export default {

    name: "delete",
    data: () => ({
        isHaveLoadeMore:false,
        LoadingLoreMore:false,
        TextLoademore:"Load More",
        isSuccess:0,
        isError:0,
        hide_action:false,
        isDelete:false,
        loadingLodemore: false,
        loadmore: "Load More",
        loadingDelete: false,
        text_delete: "Start",
        hide_option: false,
        facebook_name: "",
        ImagePhoto: "Hello",
        userData: [],
        accessToken: "",
        overlay: false,
        id_facebook: "",
        facebook_name: "",
        isLoadingPage: false,
        getPages: [],
        selectPage: [],
        LoadingPost: false,
        TextProcessLink: "Get Post",
        allContent: [],
        DeletePost: '',
        index: 0,
        num_of_delete:1,
        URLNext: ""

    }),
    created() {


        this.userData = JSON.parse(localStorage.getItem('info'))
        this.accessToken = localStorage.getItem('accessToken');

    },
    mounted() {

        this.checkExpUser()
    },
    methods: {
        stopdelete(){
            this.isError = 0
            this.isSuccess=0
            this.index = 0
            this.loadingDelete = false
            this.isDelete = false
            this.hide_option = false
            this.allContent=[]
            this.hide_action= false
            this.num_of_delete = 1
            this.LoadingLoreMore = false
            this.URLNext =""
            source.cancel('Operation canceled by the user.');
        },
        refreshData(){
            this.allContent=[]
        },
        loadMoreContent() {
            this.LoadingLoreMore = true
            if (this.URLNext != undefined || this.URLNext !="") {
                axios.get(this.URLNext).then((data) => {

                    this.hide_option =  true
                    data.data.data.forEach((item, index) => {
                        var mes = ""
                        if (data.data.data.message == undefined || data.data.data.message) {
                            mes = "No Title"
                        } else {
                            mes = data.data.data.message
                        }
                        this.allContent.push({

                            id: item.id,
                            message: mes,
                            status: ''

                        })

                    });

                    if (Object.prototype.hasOwnProperty.call(data.data.paging, "next")) {
                        // this.loadMoreContent(data.data.paging.next)
                        this.isHaveLoadeMore = true
                        this.URLNext = data.data.paging.next
                        this.LoadingLoreMore = false
                        this.hide_action= true
                    } else {
                        // console.log("Stop")
                        // this.loadMoreContent( data.data.paging.previous)
                        // this.hide_action= true
                        this.LoadingPost = false
                        this.hide_action= true
                        this.hide_option = true
                        this.LoadingLoreMore = false
                        this.isHaveLoadeMore = false

                    }
                    // console.log(obj)
                    // this.allContent = obj

                }).catch((data) => {
                    this.$swal('Error', this.errorMSG(data), 'error');
                    this.LoadingPost = false
                    this.hide_option = false
                    this.LoadingLoreMore = false

                }).finally((data) => {
                    // this.LoadingPost = false
                    // this.hide_option= false
                    // this.LoadingLoreMore = false
                    this.LoadingLoreMore = false
                })

            }

        },
        autodelete() {
            this.isDelete = true
            var $t = this
            this.loadingDelete = true
            if (this.index < this.allContent.length) {
            
                var bodyFormData ={
                    access_token:this.selectPage.access_token
                }
                axios.delete('https://graph.facebook.com/v18.0/' + this.allContent[this.index].id, {data:bodyFormData}, {
                    cancelToken: source.token
                }).then((data) => {
                    $t.num_of_delete++
                    $t.index++
                    $t.DeletePost = ""
                    $t.isSuccess++
                    $t.autodelete()
                    
                }).catch((data) => {
                    $t.num_of_delete++
                    $t.index++
                    $t.DeletePost = ""
                    $t.isDelete++
                    $t.autodelete()
                }).finally((data) => {

                })

             

            } else {
                this.done_delete()
            }

        },
        done_delete() {
            this.isError = 0
            this.isSuccess=0
            this.index = 0
            this.loadingDelete = false
            this.isDelete = false
            this.hide_option = false
            this.allContent=[]
            this.hide_action= false
            this.num_of_delete = 1
            this.LoadingLoreMore = false
            this.URLNext =""
        },
        getContent() {

            this.LoadingPost = true
            // console.log(this.selectPage.length)
            if (this.selectPage.length == 0) {
                this.LoadingPost = false
                this.$swal('Select Page', "Please select your page", 'warning');
                return
            }
            axios.get('https://graph.facebook.com/' + this.selectPage.id + '/feed',

                {
                    params: {
                        access_token: this.accessToken,
                        limit: 20,
                        fields: "id,created_time,access_token,permalink_url,message"
                    }

                }).then((data) => {
                this.hide_option = true
                var obj = []

                data.data.data.forEach((item, index) => {
                    var mes = ""
                    if (data.data.data.message == undefined || data.data.data.message) {
                        mes = "No Title"
                    } else {
                        mes = data.data.data.message
                    }
                    this.allContent.push({

                        id: item.id,
                        message: mes,
                        status: ''

                    })

                });
                // this.allContent = obj

                if (Object.prototype.hasOwnProperty.call(data.data.paging, "next")) {
                    // console.log(1)
                    console.log(data.data.paging.next)
                    this.isHaveLoadeMore = true
                    this.hide_option = true
                    this.LoadingPost = false
                    this.URLNext = data.data.paging.next
                    this.hide_action = true
                   // this.loadMoreContent(data.data.paging.next)

                } else {
                    
                     this.LoadingPost = false
                     this.hide_action= true
                     this.hide_option = true
                     this.isHaveLoadeMore = false
                }

            }).catch((data) => {
                this.$swal('Error', this.errorMSG(data), 'error');
                this.LoadingPost = false
                this.hide_option = false

            }).finally((data) => {
                // this.LoadingPost = false
                // this.hide_option= false
            })

        },
        checkExpUser() {
            axios.get('https://app.camsmartbiz.com/user/checkexp/' + this.userData.data.user.id).then((data) => {

                if (data.data.data.expired == true) {

                    this.$router.push('expired').catch(err => {})

                } else {
                    this.getProfileWithADS()
                }

            }).catch((err) => {
                this.$swal('Error', "Something Wrong !", 'error');
            }).finally(() => {

            })
        },
        getpages() {

            axios.get('https://graph.facebook.com/' + this.id_facebook + '/accounts',

                {
                    params: {
                        access_token: this.accessToken,
                        limit: 100,
                        fields: "id,name,access_token"
                    }

                }).then((data) => {

                var obj = []

                data.data.data.forEach((item, index) => {

                    obj.push({
                        name: item.name,
                        id: item.id,
                        access_token: item.access_token,
                        status: ''

                    })

                });

                this.getPages = obj
                // this.dialogChoosePage = true
                this.isLoadingPage = false

            }).catch((data) => {
                this.$swal('Error', this.errorMSG(data), 'error');
                this.isLoadingPage = false

            }).finally((data) => {
                this.isLoadingPage = false
            })
        },
        getProfileWithADS() {

            this.overlay = true
            axios.get('https://graph.facebook.com/me', {

                    params: {

                        access_token: this.accessToken

                    }
                }

            ).then((data) => {

                var hasPropertyError = Object.prototype.hasOwnProperty.call(data.data, "error");
                if (hasPropertyError) {

                    this.$swal('Profile', this.errorMSG(data), 'error');

                } else {
                    console.log(data)

                    this.id_facebook = data.data.id;

                    this.facebook_name = data.data.name

                    var urlimage = "https://graph.facebook.com/" + this.id_facebook + "/picture?height=500&access_token=6628568379%7Cc1e620fa708a1d5696fb991c1bde5662";

                    this.ImagePhoto = urlimage;
                    this.getpages()
                    // this.getAdsAccont()

                }

            }).catch((data) => {

                this.overlay = true
                this.$router.push('dashboard')

            }).finally((data) => {

                this.overlay = false

            })

        },

        errorMSG(data) {
            var msgTitle = "";
            var msgDesc = "";

            if (data.hasOwnProperty("response")) {
                if (data.response.data.error.hasOwnProperty("error_user_title")) {
                    msgTitle = data.response.data.error.error_user_title;

                    msgDesc = data.response.data.error.error_user_msg.replace(/"/g, "'");
                } else {
                    msgTitle = data.response.data.error.type;

                    msgDesc = data.response.data.error.message;
                }
            } else {
                msgTitle = "No Internet";
                msgDesc = "Please check your internet connection";
            }

            return msgDesc
        },
    }

}
</script>
